import { UPDATE_CART } from "./actionTypes";

export const updateCart = (cartProducts) => (dispatch) => {
	let productQuantity = cartProducts.reduce((sum, p) => {
		sum += parseInt(p.quantity);
		return sum;
	}, 0);

	let totalPrice = cartProducts.reduce((sum, p) => {
		sum += p.price * parseInt(p.quantity);
		return sum;
	}, 0);

	let installments = cartProducts.reduce((greater, p) => {
		greater = p.installments > greater ? p.installments : greater;
		return greater;
	}, 0);

	let cartTotal = {
		productQuantity,
		installments,
		totalPrice,
		currencyId: "RWF",
		currencyFormat: "RWF",
	};

	dispatch({
		type: UPDATE_CART,
		payload: cartTotal,
	});
};
